import React, { PropTypes } from 'react';
import _ from 'lodash';
import $ from 'jquery';
import { Modal, Button, Col, Row, Well, HelpBlock } from 'react-bootstrap';
import { TextField, ReadOnlyField } from './AdminComponents';
import { browserHistory } from 'react-router';
import Select from 'react-select';

export default class AdminRoleCt extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enableEdit: props.route.type === 'add' ? true : false,
      showErrorMsg: false,
      role_name_value: '',
      is_loaded_role_data: false,
      role_data: [],
      main_role_option: '',
      is_loaded_usergroup_data: false,
      usergroup_data: [],
      department_option: '',
    }

    this.onChangeHandler = this.onChangeHandler.bind(this)
    this.onChangeMainRole = this.onChangeMainRole.bind(this)
    this.onChangeDepartment = this.onChangeDepartment.bind(this)
  }

  componentDidMount() {

    this.loadUserGroupData()
    this.loadRoleData()
  }

  componentDidUpdate() {

    const { type } = this.props.route
    const { is_loaded_role_data, is_loaded_usergroup_data, role_data, usergroup_data, main_role_id, department_id, main_role_option, department_option } = this.state

    if (type === 'edit'
      && is_loaded_role_data === true
      && is_loaded_usergroup_data === true
      && main_role_option === ''
      && department_option === ''
      && main_role_id !== ''
      && department_id !== '') {

      this.setState({ main_role_option: _.find(role_data, { value: main_role_id }), department_option: _.find(usergroup_data, { value: department_id }) });
    }
  }

  loadRoleData() {

    const { id } = this.props.params
    let role_name = ''
    let main_role_id = ''
    let department_id = ''

    $.ajax({
      type: 'get',
      url: '/api/W_Role_Get.php',
      success: response => {
        if (id !== undefined) {
          let find_data = _.find(response.result, { sub_role: id })
          role_name = find_data.role_name
          main_role_id = find_data.main_role
          department_id = find_data.department_id
        }

        let role_data = response.result.map((x, y) => {
          return { value: x.sub_role, label: x.role_name }
        })
        this.setState({ role_name_value: role_name, main_role_id: main_role_id, department_id: department_id, role_data: role_data, is_loaded_role_data: true });
      },
      error: (xhr, ajaxOptions, thrownError) => { },
    });
  }

  loadUserGroupData() {

    $.ajax({
      type: 'get',
      url: '/api/W_UserGroup_Get.php',
      success: response => {
        let usergroup_data = response.result.map((x, y) => {
          return { value: x.id, label: x.name }
        })
        this.setState({ usergroup_data: usergroup_data, is_loaded_usergroup_data: true });
      },
      error: (xhr, ajaxOptions, thrownError) => { },
    });
  }

  onSubmit() {

    const { params, route } = this.props
    const { role_name_value, main_role_option, department_option } = this.state

    if (role_name_value === '' || main_role_option === '' || department_option === '') {

      this.setState({ showErrorMsg: true })
    }
    else {

      let formData = new FormData();
      formData.append('main_role', main_role_option.value);        //群組名稱
      formData.append('role_name', role_name_value);        //群組名稱
      formData.append('department_id', department_option.value);        //群組名稱

      if (route.type === 'edit') {
        formData.append('sub_role', params.id)
      }

      $.ajax({
        type: 'post',
        url: route.type === 'add' ? '/api/W_Role_Post.php' : '/api/W_Role_Update.php',
        data: formData,
        processData: false,
        contentType: false,
        success: response => {
          if (response.status === '0') {//成功

            this.setState({ enableEdit: false })
            this.props.reloadData();
            browserHistory.push('/salesky/admin/Role/' + response.result.sub_role);
          }
          else {
            alert(response.msg);
          }
        },
        error: error => { },
        // complete: ()=> {
        //     this.loadOneNews();//重刷頁面
        //     this.props.reloadDataList();//newsDataTable也要重刷頁面
        // },
      });
    }
  }

  onChangeHandler(stateName, event) {

    let newState = {};
    newState[stateName] = event.target.value;
    this.setState(newState);
  }

  onChangeMainRole(options) {

    this.setState({ main_role_option: options })
  }

  onChangeDepartment(options) {

    this.setState({ department_option: options })
  }

  onRemove() {

    const { closeModal, params } = this.props

    let formData = new FormData();
    formData.append('sub_role', params.id);

    if (confirm('確定刪除嗎?')) {

      $.ajax({
        type: 'post',
        url: '/api/W_Role_Delete.php',
        data: formData,
        processData: false,
        contentType: false,
        success: response => {
          if (response.status === '0') {//成功

            // this.setState({ enableEdit: false })
            this.props.reloadData();
            closeModal()
          }
          else {
            alert(response.msg);
          }
        },
        error: error => { },
      });
    }
  }

  renderBtns() {

    const { closeModal, params, route } = this.props
    const { enableEdit } = this.state

    let remove_btn = (route.type === 'edit' && enableEdit === true) ? <Button onClick={() => this.onRemove()}>刪除</Button> : null
    let edit_btn = enableEdit === true ? <Button onClick={() => this.onSubmit()}>儲存</Button> : <Button onClick={() => this.setState({ enableEdit: true })}>編輯</Button>

    if (params.id !== '1') {

      return (
        <div>
          {remove_btn}
          {edit_btn}
          <Button onClick={closeModal}>關閉</Button>
        </div>
      )
    }
    else {

      return <Button onClick={closeModal}>關閉</Button>
    }
  }

  render() {

    const { route } = this.props;
    const { enableEdit, showErrorMsg, main_role_option, department_option, role_name_value, role_data, usergroup_data } = this.state

    let title = '新角色名稱'
    if (route.type === 'edit') {
      title = enableEdit === false ? '檢視角色名稱' : '編輯角色名稱'
    }

    return (
      <div>
        <Modal
          show={true}
          bsSize="large"
          className="div-newsCt"
          keyboard={false}
          backdrop="static"
        // onHide={closeModal}
        >
          <Modal.Header>
            <Modal.Title>{title}</Modal.Title>
            <span className="span-newsModalBtn">
              {this.renderBtns()}
            </span>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={12}>
                <div style={{ fontWeight: "bold" }}><span style={{ color: "red" }}>* </span>父階角色</div>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <Well>
                  <Select
                    disabled={!enableEdit}
                    value={main_role_option}
                    placeholder="請選擇"
                    options={role_data}
                    onChange={this.onChangeMainRole}
                  />
                  {
                    (showErrorMsg && main_role_option === '') ? <HelpBlock>此欄位請勿空白</HelpBlock> : null
                  }
                </Well>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <div style={{ fontWeight: "bold" }}><span style={{ color: "red" }}>* </span>角色名稱</div>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <Well>
                  {
                    enableEdit ?
                      <TextField
                        fieldName='role_name_value'
                        fieldValue={role_name_value}
                        onChangeHandler={this.onChangeHandler}
                        showErrorMsg={showErrorMsg}
                      />
                      : <ReadOnlyField fieldValue={role_name_value} />
                  }
                </Well>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <div style={{ fontWeight: "bold" }}><span style={{ color: "red" }}>* </span>部門名稱</div>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <Well>
                  <Select
                    disabled={!enableEdit}
                    value={department_option}
                    placeholder="請選擇"
                    options={usergroup_data}
                    onChange={this.onChangeDepartment}
                  />
                  {
                    (showErrorMsg && department_option === '') ? <HelpBlock>此欄位請勿空白</HelpBlock> : null
                  }
                </Well>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            {this.renderBtns()}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

AdminRoleCt.prototypes = {
  closeModal: PropTypes.func.isRequired,
}





// WEBPACK FOOTER //
// ./src/salesky/routes/admin/AdminRoleCt.jsx